var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoStarsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.207,
    height: 72.639,
    viewBox: "0 0 56.207 72.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_352",
    x: 0,
    y: 0,
    width: 56.207,
    height: 56.239,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_353",
    x: 9.598,
    y: 35.6,
    width: 37.011,
    height: 37.038,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    transform: "translate(-1526.896 -235.659)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1526.9, 235.66)",
    filter: "url(#Path_352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352-2",
    "data-name": "Path 352",
    d: "M303.309,142.716a4.329,4.329,0,0,1-3.752,2.089,8.849,8.849,0,0,0-8.406,8.574c-.159,2.225-1.327,3.566-3.179,3.646-1.948.084-3.1-1.037-3.413-3.315-.053-.383-.138-.761-.192-1.144a8.835,8.835,0,0,0-8.274-7.766c-2.232-.17-3.339-.891-3.835-2.5a3.166,3.166,0,0,1,2.373-4c.992-.207,2.028-.217,3.01-.454a8.955,8.955,0,0,0,6.721-7.54c.08-.574.159-1.148.245-1.721a3.217,3.217,0,0,1,6.254-.55,6.853,6.853,0,0,1,.286,1.561,8.826,8.826,0,0,0,8.242,8.432c1.609.165,3.052.556,3.92,2.073Z",
    transform: "matrix(0.97, -0.26, 0.26, 0.97, -286.41, -37.01)",
    fill: "#ffbf0f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1526.9, 235.66)",
    filter: "url(#Path_353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_353-2",
    "data-name": "Path 353",
    d: "M290.811,135.935a2.594,2.594,0,0,1-2.248,1.252,5.3,5.3,0,0,0-5.037,5.138c-.1,1.334-.8,2.137-1.9,2.185-1.167.05-1.857-.621-2.045-1.987-.032-.229-.083-.456-.115-.685a5.294,5.294,0,0,0-4.958-4.654c-1.338-.1-2-.534-2.3-1.5a1.9,1.9,0,0,1,1.422-2.395c.594-.124,1.215-.13,1.8-.272a5.366,5.366,0,0,0,4.027-4.518c.048-.344.1-.688.147-1.032a1.928,1.928,0,0,1,3.747-.33,4.1,4.1,0,0,1,.171.936,5.289,5.289,0,0,0,4.939,5.053,2.722,2.722,0,0,1,2.349,1.242Z",
    transform: "translate(-250.96 -88.93) rotate(1)",
    fill: "#ffbf0f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoStarsIcon);
export default __webpack_public_path__ + "static/media/two_stars_icon.da39aa88f14d32d11156f5661011cd3e.svg";
export { ForwardRef as ReactComponent };